import axios from 'axios'
const uri = 'gestion-cuentas-email/php/'
const get = (url) => {
	return axios.get(uri + url)
}
const post = (url, datos) => {
	return axios.post(uri + url, datos)
}

export default {
	getDominios () {
		return get('getDominios.php')
	},
	getCuentas () {
		return get('getCuentas.php')
	},

	getCuenta (idCuenta) {
		const datos = {
			idCuenta: idCuenta
		}
		return post('getCuenta.php', datos)
	},

	getAlias (origen, dominio) {
		const datos = {
			origen: origen,
			dominio_origen: dominio
		}
		return post('getAlias.php', datos)
	},

	getAliases () {
		return get('getAliases.php')
	},

	setCuenta (datos) {
		return post('setCuenta.php', datos)
	},

	setAlias (datos) {
		return post('setAlias.php', datos)
	},

	delCuenta (idCuenta) {
		const datos = {
			idCuenta: idCuenta
		}
		return post('delCuenta.php', datos)
	},

	eliminarAlias (datos) {
		return post('delAliasCompleto.php', datos)
	},

	delAlias (datos) {
		return post('delAlias.php', datos)
	},

	setToken (idCuenta, nombre) {
		const datos = {
			idCuenta: idCuenta,
			nombre: nombre
		}
		return post('setToken.php', datos)
	},

	delToken (idToken) {
		const datos = {
			idToken: idToken
		}
		return post('delToken.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-cuentas-email/vue/api.js